import { faFilePdf } from '@fortawesome/pro-regular-svg-icons'
import { Button, Icon, State, Toast } from '@seiue/ui'
import { Upload, UploadFile } from 'antd'
import { RcFile, UploadProps } from 'antd/lib/upload'
import { useAtomValue } from 'jotai'
import { FC, useState } from 'react'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'
import { FileDirName } from 'packages/sdks-next/growp'
import { uploadFile } from 'packages/utils'

import { WaringText } from '@/components/Styled'
import { getTheme } from '@/utils/theme'

import { FileDisplay, DisplayMsgLabel, UploadButton, Tips } from './Styled'
import { UploadTaskFileProps } from './UploadTaskFile'
import { validFileExistAtom } from './atom'

/**
 * 上传pdf组件
 *
 * @param param0 - 参数
 * @param param0.setFile - 设置表单文件
 * @param param0.file - 表单文件
 * @returns 上传pdf组件
 */
export const UploadPdf: FC<UploadTaskFileProps> = ({
  setFile: setFormFile,
  file: formFile,
}) => {
  const [file, setFile] = useState<UploadFile | undefined>(formFile)

  const validFileExist = useAtomValue(validFileExistAtom)

  const [loading, setLoading] = useState<boolean>(false)

  const theme = getTheme()

  const beforeUpload: UploadProps['beforeUpload'] = async (
    file: RcFile & { url?: string }
  ) => {
    const fileSizeM = file.size / 1024 / 1024
    if (fileSizeM > 50) {
      Toast.warning(`请上传体积小于 50M 的 PDF 文件`)

      file.url = undefined
      return false
    }
    setLoading(true)
    const { data } = await uploadFile({
      file,
      dirname: FileDirName.File,
    })

    file.url = data?.url
    if (data) {
      setFile(file)
      setFormFile({
        name: file?.name,
        size: file?.size,
        type: file?.type,
        uid: file?.uid,
        url: data.url,
      })
      setLoading(false)
    }

    return file
  }

  return (
    <div>
      {!file ? (
        loading ? (
          <State.Loading
            style={{ minHeight: 16, position: 'absolute', top: 0, left: 8 }}
          />
        ) : (
          <UploadDisplay>
            <Upload
              accept=".pdf"
              beforeUpload={beforeUpload}
              fileList={[]}
            >
              <UploadButton
                $backgroundColor={
                  !file && validFileExist
                    ? theme.status.danger.backgroundLight
                    : undefined
                }
              >
                <GrowpIcon name="Jiahao" />
                <div>{'上传PDF'}</div>
              </UploadButton>
            </Upload>
            <Tips>{'文件大小上限50Mb，支持格式pdf'}</Tips>
            {!file && validFileExist ? (
              <WaringText>{'请上传 Pdf 文件'}</WaringText>
            ) : null}
          </UploadDisplay>
        )
      ) : (
        <PdfDisplay style={{ display: file ? 'flex' : 'none' }}>
          <PdfSpace onClick={() => window.open(file.url, '_blank')}>
            <Icon icon={faFilePdf} />
          </PdfSpace>
          <FileDisplay>
            <DisplayMsgLabel>{`文件名称：${file?.name}`}</DisplayMsgLabel>
            <OperateBtns>
              <Upload
                accept=".pdf"
                beforeUpload={beforeUpload}
                fileList={[]}
              >
                <Button
                  type="link"
                  style={{
                    color: theme.brand._1,
                    border: 'none',
                  }}
                >
                  {'更换'}
                </Button>
              </Upload>
              <Button
                type="link"
                onClick={() => {
                  setFile(undefined)
                  setFormFile(undefined)
                }}
                style={{ color: theme.status.danger.element }}
              >
                {'删除'}
              </Button>
            </OperateBtns>
          </FileDisplay>
        </PdfDisplay>
      )}
    </div>
  )
}

const PdfSpace = styled.div`
  width: 142px;
  height: 80px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${(props) => props.theme.brand._4};
`
const UploadDisplay = styled.div`
  &&& {
    .ant-upload-list {
      display: none;
    }
  }
`
const PdfDisplay = styled.div`
  align-items: center;
  gap: 20px;
`

const OperateBtns = styled.div`
  display: flex;
`
